import React from 'react'

const AddModal = () => {
  return (
    <div>AddModal</div>
  )
}

export default AddModal